import { Trophy, Calendar } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { useEffect, useState } from "react";

const OffersPanel = () => {
  const [api, setApi] = useState<any>(null);

  const offers = [
    {
      quote: "I'm excited to share that I've passed the interviews and secured the E7 level. I truly appreciate your guidance in ML system design and the mock sessions. I've benefited tremendously not only on the technical side but also in how to present my ideas clearly and persuasively. Thank you again for your time and support throughout this process.",
      author: "E7 from TikTok (secured offer at Meta)",
      date: "Jul 2025"
    },
    {
      quote: "Thanks for the great feedback! Immensely helpful discussion and I got a lot of value out of the session esp understanding the expectations around equations, trade-offs and prob formulation at L6/7 level.",
      author: "Senior EM (Meta)/ Ex-Linkedin",
      date: ""
    }
  ];

  useEffect(() => {
    if (!api) return;

    const interval = setInterval(() => {
      api.scrollNext();
    }, 3000); // Auto-rotate every 3 seconds

    return () => clearInterval(interval);
  }, [api]);

  return (
    <Card className="border-primary/20 bg-gradient-to-br from-primary/5 to-primary/10">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Trophy className="h-5 w-5 text-primary" />
          Recent Offers
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4">
        <Carousel className="w-full" setApi={setApi}>
          <CarouselContent>
            {offers.map((offer, index) => (
              <CarouselItem key={index}>
                <div className="p-1">
                  <Card className="bg-background/80 backdrop-blur-sm">
                    <CardContent className="p-4">
                      <blockquote className="text-sm mb-3 leading-relaxed">
                        "{offer.quote}"
                      </blockquote>
                      <div className="flex items-center justify-between">
                        <footer className="text-sm font-medium text-muted-foreground">
                          {offer.author}
                        </footer>
                        {offer.date && (
                          <Badge variant="secondary" className="flex items-center gap-1">
                            <Calendar className="h-3 w-3" />
                            {offer.date}
                          </Badge>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center gap-2 mt-4">
            <CarouselPrevious className="static transform-none" />
            <CarouselNext className="static transform-none" />
          </div>
        </Carousel>
      </CardContent>
    </Card>
  );
};

export default OffersPanel;